import { createSlice } from "@reduxjs/toolkit";
const initialAppointmentState = {
  appointment: {
    isModalOpen: false,
    date: null,
    time: "",
    name: null,
    phone: null,
    email: null,
    availableTimeSlots: {},
  },
};

const appointmentSlice = createSlice({
  name: "appointment",
  initialState: initialAppointmentState,
  reducers: {
    setIsModalOpen(state, action) {
      state.appointment.isModalOpen = action.payload;
    },
    setDate(state, action) {
      state.appointment.date = action.payload;
    },
    setAvailableTimeSlots(state, action) {
      state.appointment.availableTimeSlots = action.payload;
    },
    setTime(state, action) {
      state.appointment.time = action.payload;
    },
    setName(state, action) {
      state.appointment.name = action.payload;
    },
    setPhone(state, action) {
      state.appointment.phone = action.payload;
    },
    setEmail(state, action) {
      state.appointment.email = action.payload;
    },
    clearAppointmentData(state) {
      state.appointment.date = null;
      state.appointment.availableTimeSlots = null;
      state.appointment.time = "";
      state.appointment.name = null;
      state.appointment.phone = null;
      state.appointment.email = null;
    },
  },
});

export const appointmentActions = appointmentSlice.actions;

export default appointmentSlice.reducer;
